export const timeDifference = (timestamp) => {
  var date1 = new Date();
  var date2 = new Date(timestamp);
  var difference = date1.getTime() - date2.getTime();

  var daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
  difference -= daysDifference * 1000 * 60 * 60 * 24;

  var hoursDifference = Math.floor(difference / 1000 / 60 / 60);
  difference -= hoursDifference * 1000 * 60 * 60;

  var minutesDifference = Math.floor(difference / 1000 / 60);
  difference -= minutesDifference * 1000 * 60;

  var secondsDifference = Math.floor(difference / 1000);
  if (daysDifference) {
    if (daysDifference == 1) {
      return daysDifference + " day";
    } else {
      return daysDifference + " days";
    }
  } else if (hoursDifference) {
    if (hoursDifference == 1) {
      return hoursDifference + " hour";
    } else {
      return hoursDifference + " hours";
    }
  } else if (minutesDifference) {
    if (minutesDifference == 1) {
      return minutesDifference + " minute";
    } else {
      return minutesDifference + " minutes";
    }
  } else if (secondsDifference) {
    if (secondsDifference == 1) {
      return secondsDifference + " second";
    } else {
      return secondsDifference + " seconds";
    }
  } else {
    return "1 second";
  }
};

export const shortString = (yourString, maxLength) => {
  if (typeof yourString !== "undefined") {
    //Trim and re-trim only when necessary (prevent re-trim when string is shorted than maxLength, it causes last word cut)
    if (yourString.length > maxLength) {
      //trim the string to the maximum length
      var trimmedString = yourString.substr(0, maxLength);

      //re-trim if we are in the middle of a word and
      // if(trimmedString.lastIndexOf(" ")!==-1) {
      //     trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))
      // }
      return trimmedString + "...";
    } else {
      return yourString;
    }
  } else {
    return yourString;
  }
};

export const selectAllText = (event) => {
  var range = document.createRange();
  range.selectNodeContents(event.target);
  var sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
};
